import { dataSlidersSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSlidersSquareSolid = /*#__PURE__*/createIcon(dataSlidersSquareSolid)
export default IconSlidersSquareSolid
